import Vue from 'vue';

export default Vue.extend({
  name: 'ElDatePickerMixin',

  data(): {
    readonly monthFormat: string;
    readonly monthNumberFormat: string;
    readonly dateFormat: string;
  } {
    return {
      monthFormat: 'yyyy/MM',
      monthNumberFormat: 'yyyyMM',
      dateFormat: 'yyyy/MM/dd',
    };
  },
});
